/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Authagreementterms2Inputs */



/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Authagreementterms2Inputs} inputs
* @param {{ locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }} options
* @returns {LocalizedString}
*/
const authagreementterms2 = /** @type {((inputs?: Authagreementterms2Inputs, options?: { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authagreementterms2Inputs, { locale?: "ja-JP" | "en-US" | "fr-FR" | "de-DE" | "zh-TW" | "ko-KR" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-US") return /** @type {LocalizedString} */ ("Terms of Service")
	if (locale === "fr-FR") return /** @type {LocalizedString} */ ("Conditions d'utilisation")
	if (locale === "de-DE") return /** @type {LocalizedString} */ ("Nutzungsbedingungen")
	if (locale === "zh-TW") return /** @type {LocalizedString} */ ("服務條款")
	if (locale === "ko-KR") return /** @type {LocalizedString} */ ("이용약관")
	return /** @type {LocalizedString} */ ("利用規約")
});
export { authagreementterms2 as "authAgreementTerms" }